export const DOMAIN = "https://movie0706.cybersoft.edu.vn/api/"